import { Popover, Space, Table, Tag, Tooltip } from "antd";
import moment from "moment";
import { ChangeEvent, useEffect, useState } from "react";
import { pageSizeOptionsPaging } from "utils/constant";
import { REGISTER_STATUS_CONFIG } from "utils/shipment";
import { SortSvgBottom, SortSvgTop } from "utils/svgs";
// import { invalidText } from "utils/utils";
import SearchAndFilter from "../SearchAndFilter";
import styles from "./index.module.scss";
import DropdownComponent from "components/Global/Dropdown";
import {
  ClockCircleOutlined,
  EditOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import SparePartDetailsModal from "./ViewSparseItemModal";
import { getApi } from "redux/apis";
import UseDateLogModal from "./ViewDateLogModal";
import ViewDateLogModal from "./ViewDateLogModal";

const { Column } = Table;
interface Props {
  allRegisterData: any;
  setSelectedRegisterSP: (data: any) => void;
  paginationChangeHandler: (pageNo: number, pageSize: number) => void;
  currentPage: number;
  totalRecords: number;
  performSearchHandler: (event: ChangeEvent<HTMLInputElement>) => void;
  searchValue: string;
  openModalHandler: () => void;
  performSortHandler?: (type: string, current: string) => void;
  modifyPageSize: any;
  PageSize: number;
  sortDirection?: any;
  isLoading: boolean;
  handleOk: any;
  handleServiceCenterChange: any;
  selectedServiceCenter: any;
  handleSparePartsChange: any;
  selectedSpareParts: any;
  fetchSpareParts: any;
  handleFromDateChange: any;
  handleToDateChange: any;
  fromDate: any;
  toDate: any;
  handleSalesOrderNumberChange: any;
  selectedSalesOrderNumbers: any;
  handleProductNameChange: any;
  selectedProductName: any;
  isServiceCenter: any;
  handleSelectedStatus: any;
  selectedStatus: any;
  isEmployee: any;
  setFiltersReset: any;
  rowSelection?: any;
  selectedRowKeys?: string[];
  handleDeleteClick?: () => void;
  canDelete?: boolean;
}
const SortingIcon = (data: any) => {
  return data.data.sortOrder === "ascend" ? <SortSvgTop /> : <SortSvgBottom />;
};

const RegisterSparePartTable = (props: Props) => {
  const {
    allRegisterData,
    isLoading,
    setSelectedRegisterSP,
    openModalHandler,
    totalRecords,
    searchValue,
    performSearchHandler,
    currentPage,
    performSortHandler,
    PageSize,
    modifyPageSize,
    paginationChangeHandler,
    sortDirection,
    isServiceCenter,
    handleOk,
    handleServiceCenterChange,
    selectedServiceCenter,
    handleSparePartsChange,
    selectedSpareParts,
    handleFromDateChange,
    handleToDateChange,
    fromDate,
    toDate,
    fetchSpareParts,
    handleSalesOrderNumberChange,
    selectedSalesOrderNumbers,
    handleProductNameChange,
    selectedProductName,
    handleSelectedStatus,
    selectedStatus,
    isEmployee,
    setFiltersReset,
    rowSelection,
    selectedRowKeys,
    handleDeleteClick,
    canDelete = false,
  } = props;

  // const [expandedRowKeys, setExpandedRowKeys] = useState<string[]>([]);
  // console.log("All Register Data in table:", allRegisterData);

  const editDataHandler = (data: any) => {
    openModalHandler();
    setSelectedRegisterSP(data);
  };

  const tableChangeHandler = (pageInfo: any, d: any, columnInfo: any) => {
    performSortHandler &&
      performSortHandler(columnInfo.order, columnInfo?.column?.key);
  };

  const [visible, setVisible] = useState(false);
  const [sparePartDetails, setSparePartDetails] = useState<any>(null);
  const [serviceCenters, setServiceCenters] = useState([]);

  const [logVisible, setLogVisible] = useState(false);
  const [logData, setLogData] = useState<any[]>([]);
  const [logItem, setLogItem] = useState("");
  const [logLoading, setLogLoading] = useState(false);
  const [selectedServiceCenterId, setSelectedServiceCenterId] =
    useState<string>("");

  //    const fetchInventoryLogs = async (sparePartItem: string, serviceCenterId: string) => {
  //   try {
  //     setLogLoading(true);
  //     const response = await getApi(`/inventory/logs/${sparePartItem}/${serviceCenterId}`);

  //     if (response.data.success) {
  //       setLogData(response.data.data);
  //     } else {
  //       console.error('Failed to fetch inventory logs:', response.data.message);
  //       // Fallback to empty array if API fails
  //       setLogData([]);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching inventory logs:', error);
  //     // Fallback to empty array if API fails
  //     setLogData([]);
  //   } finally {
  //     setLogLoading(false);
  //   }
  // };

  const openLog = (data: any) => {
    console.log("Opening log for:", data);
    setLogItem(data?.sparePartItem);
    setSelectedServiceCenterId(data?.serviceCenterId);
    setLogVisible(true);
    // Remove the fetchInventoryLogs call since modal will handle it internally
    // fetchInventoryLogs(data?.sparePartItem, data?.serviceCenterId);
  };

  const closeLogModal = () => {
    setLogVisible(false);
    setLogData([]);
    setLogItem("");
    setSelectedServiceCenterId("");
  };

  const openModal = (details) => {
    console.log("details open in modal", details);
    setVisible(true);
    setSparePartDetails(details);
  };

  const closeModal = () => {
    setVisible(false);
    setSparePartDetails(null);
  };

  useEffect(() => {
    const fetchServiceCenters = async () => {
      try {
        const response = await getApi("/serviceCenter/shipment-dropdown");
        if (response.data.success) {
          const formattedCenters = response.data.data.map((center: any) => ({
            value: center.id,
            label: center.name,
          }));
          setServiceCenters(formattedCenters);
        }
      } catch (error) {
        console.error("Failed to fetch service centers:", error);
      }
    };

    fetchServiceCenters();
  }, []);

  console.log(allRegisterData);

  // const expandedRowRender = (record: any) => {

  //   console.log("Expanded Record in reg table:", record);
  //   return (
  //     <Table
  //       dataSource={[record]} // Pass the current record as the dataSource
  //       pagination={false}
  //       className="bg-white"
  //       style={{ width: "100%", padding: "1.5rem 0px" }}
  //       key={record.id}
  //     >
  //       <Column
  //         title="SparePart Description"
  //         dataIndex="itemDescription"
  //         key="itemDescription"
  //         className="bg-white"
  //         render={(text: string) => {
  //           if (!text) return "-";
  //           if (text.length > 30) {
  //             return (
  //               <Popover
  //                 content={text}
  //                 trigger="hover"
  //                 destroyTooltipOnHide
  //                 mouseLeaveDelay={0.1}
  //               >
  //                 <span>{text.slice(0, 30)}...</span>
  //               </Popover>
  //             );
  //           }
  //           return text;
  //         }}
  //       />
  //       <Column
  //         title="Product Name"
  //         dataIndex="productName"
  //         key="productName"
  //         className="bg-white"
  //         render={(text: string) => {
  //           if (invalidText(text)) return "-";
  //           if (text && text.length > 20) {
  //             // Adjust the length threshold as needed
  //             return (
  //               <Popover
  //                 content={text}
  //                 trigger="hover"
  //                 destroyTooltipOnHide
  //                 mouseLeaveDelay={0.1}
  //               >
  //                 <span>{text.slice(0, 20)}...</span>
  //               </Popover>
  //             );
  //           }
  //           return text;
  //         }}
  //       />
  //       <Column
  //         title="Product Description"
  //         dataIndex="productDescription"
  //         key="productDescription"
  //         className="bg-white"
  //         render={(text: string) => {
  //           if (invalidText(text)) return "-";
  //           if (text && text.length > 20) {
  //             // Adjust the length threshold as needed
  //             return (
  //               <Popover
  //                 content={text}
  //                 trigger="hover"
  //                 destroyTooltipOnHide
  //                 mouseLeaveDelay={0.1}
  //               >
  //                 <span>{text.slice(0, 20)}...</span>
  //               </Popover>
  //             );
  //           }
  //           return text;
  //         }}
  //       />
  //       <Column
  //         title="Customer Name"
  //         dataIndex="customerName"
  //         key="customerName"
  //         className="bg-white"
  //         render={(text: string) => (invalidText(text) ? "-" : text)}
  //       />
  //       <Column
  //         title="Service Center Ticket Number"
  //         dataIndex="serviceCenterTicket"
  //         key="serviceCenterTicket"
  //         className="bg-white"
  //         render={(text: string) => (invalidText(text) ? "-" : text)}
  //       />
  //       <Column
  //         title="Comment"
  //         dataIndex="registerComments"
  //         key="registerComments"
  //         className="bg-white"
  //         render={(text: string) => {
  //           const invalidText = (value: string) =>
  //             !value || value.trim() === "";

  //           if (invalidText(text)) return "-";

  //           const maxLength = 20; // Adjust the threshold if needed
  //           const isTruncated = text.length > maxLength;

  //           if (isTruncated) {
  //             return (
  //               <Popover
  //                 content={text}
  //                 trigger="hover"
  //                 destroyTooltipOnHide
  //                 mouseLeaveDelay={0.1}
  //               >
  //                 <span>{text.slice(0, maxLength)}...</span>
  //               </Popover>
  //             );
  //           }

  //           return text;
  //         }}
  //       />
  //     </Table>
  //   );
  // };

  // const onExpandRow = (expanded: boolean, record: any) => {
  //   if (expanded) {
  //     setExpandedRowKeys([record.id]);
  //   } else {
  //     setExpandedRowKeys([]);
  //   }
  // };

  // useEffect(() => {
  //   setExpandedRowKeys([]);
  // }, [
  //   searchValue,
  //   selectedServiceCenter,
  //   selectedSpareParts,
  //   selectedSalesOrderNumbers,
  //   selectedProductName,
  //   selectedStatus,
  //   fromDate,
  //   toDate,
  //   currentPage,
  //   sortDirection,
  // ]);

  return (
    <div className={styles["register-table__wrapper"]}>
      <div className={styles["dropdown__wrapper"]}>
        <DropdownComponent
          options={
            serviceCenters.length > 1
              ? [{ value: "all", label: "All" }, ...serviceCenters]
              : serviceCenters
          }
          placeholder="Select Service Center"
          value={
            serviceCenters.length === 0
              ? []
              : serviceCenters.length === 1
              ? [serviceCenters[0].value]
              : selectedServiceCenter && Array.isArray(selectedServiceCenter)
              ? selectedServiceCenter
              : []
          }
          onChange={handleServiceCenterChange}
          isLoading={isLoading}
        />
      </div>

      <SearchAndFilter
        performSearchHandler={performSearchHandler}
        searchValue={searchValue}
        isServiceCenter={isServiceCenter}
        handleServiceCenterChange={handleServiceCenterChange}
        selectedServiceCenter={selectedServiceCenter}
        handleSparePartsChange={handleSparePartsChange}
        selectedSpareParts={selectedSpareParts}
        handleFromDateChange={handleFromDateChange}
        handleToDateChange={handleToDateChange}
        onApply={handleOk}
        fromDate={fromDate}
        toDate={toDate}
        handleSalesOrderNumberChange={handleSalesOrderNumberChange}
        selectedSalesOrderNumbers={selectedSalesOrderNumbers}
        handleProductNameChange={handleProductNameChange}
        selectedProductName={selectedProductName}
        fetchSpareParts={fetchSpareParts}
        handleStatusChange={handleSelectedStatus}
        selectedStatus={selectedStatus}
        setFiltersReset={setFiltersReset}
        handleDeleteClick={handleDeleteClick}
        selectedRowKeys={selectedRowKeys}
        canDelete={canDelete}
      />

      <Table
        dataSource={allRegisterData}
        rowKey={(record) => record.id}
        loading={isLoading}
        onChange={tableChangeHandler}
        rowSelection={rowSelection}
        pagination={{
          total: totalRecords,
          current: currentPage,
          onChange: paginationChangeHandler,
          pageSize: PageSize,
          pageSizeOptions: pageSizeOptionsPaging,
          showSizeChanger: true,
          onShowSizeChange: modifyPageSize,
        }}
        scroll={{
          y: "calc(100vh - 490px)",
          x: allRegisterData.length > 0 ? "100%" : "0",
        }}
      >
        {/* <Column
          title="#"
          className="bg-white"
          key="serialNumber"
          width={"8%"}
          render={(_: any, __: any, index: number) =>
            (currentPage - 1) * PageSize + index + 1
          }
        /> */}
        <Column
          title="Service Center"
          dataIndex="serviceCenter"
          key="serviceCenter"
          className="bg-white"
          width={"30%"}
          showSorterTooltip={{ title: "" }}
          render={(text: string) => (
            <Tooltip title={text}>
              {text?.length > 50 ? `${text.slice(0, 50)}...` : text}
            </Tooltip>
          )}
        />

        <Column
          title="Spare Part Item"
          dataIndex="sparePartItem"
          key="itemNumber"
          className="bg-white"
          width={"19%"}
          showSorterTooltip={{ title: "" }}
          defaultSortOrder={sortDirection}
          sorter={() => {
            return null as any;
          }}
          sortDirections={["ascend", "descend", "ascend"]}
          sortIcon={(data) => <SortingIcon data={data} />}
          render={(text: string) => {
            if (text && text.length > 20) {
              return (
                <Popover
                  content={text}
                  trigger="hover"
                  destroyTooltipOnHide
                  mouseLeaveDelay={0.1}
                >
                  <span>{text.slice(0, 20)}...</span>
                </Popover>
              );
            }
            return text;
          }}
        />
        <Column
          title="Description"
          dataIndex="itemDescription"
          key="itemDescription"
          className="bg-white"
          width={"30%"}
          showSorterTooltip={{ title: "" }}
          render={(text: string) => (
            <Tooltip title={text}>
              {text?.length > 50 ? `${text.slice(0, 50)}...` : text}
            </Tooltip>
          )}
        />
        {/* <Column
          title="Arrival Date"
          dataIndex="arrivalDate"
          key="arrivalDate"
          className="bg-white"
          width={"20%"}
          showSorterTooltip={{ title: "" }}
          defaultSortOrder={sortDirection}
          sorter={() => {
            return null as any;
          }}
          sortDirections={["ascend", "descend", "ascend"]}
          sortIcon={(data) => <SortingIcon data={data} />}
          render={(text: string) =>
            text ? moment(text).format("MM/DD/YYYY") : "-"
          }
        />
        <Column
          title="Spare Part Item"
          dataIndex="sparePartItem"
          key="sparePartItem"
          className="bg-white"
          width={"18%"}
          render={(text: string) => (invalidText(text) ? "-" : text)}
        />
        <Column
          title="Use Date"
          dataIndex="useDate"
          key="useDate"
          className="bg-white"
          width={"15%"}
          showSorterTooltip={{ title: "" }}
          defaultSortOrder={sortDirection}
          sorter={() => {
            return null as any;
          }}
          sortDirections={["ascend", "descend", "ascend"]}
          sortIcon={(data) => <SortingIcon data={data} />}
          render={(text: string) => {
            // Check if text is "-" or invalid
            if (
              !text ||
              text === "-" ||
              text === "null" ||
              text === "undefined"
            ) {
              return "-";
            }

            // Try to parse the date and check if it's valid
            const date = moment(text);
            if (!date.isValid()) {
              return "-";
            }

            return date.format("MM/DD/YYYY");
          }}
        /> */}
        <Column
          title="Remaining Items"
          dataIndex="remainingItems"
          key="remainingItems"
          className="bg-white"
          width={"19%"}
        />
        <Column
          title="Status"
          dataIndex="status"
          key="status"
          className="bg-white"
          width={"12%"}
          showSorterTooltip={{ title: "" }}
          defaultSortOrder={sortDirection}
          sorter={() => {
            return null as any;
          }}
          sortDirections={["ascend", "descend", "ascend"]}
          sortIcon={(data) => <SortingIcon data={data} />}
          render={(status: string) => {
            // Capitalizing first letter of each word
            const formattedStatus = status
              ?.replace(/_/g, " ") // Replaces underscores with spaces
              .toLowerCase() // Converts the string to lowercase
              .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalizes the first letter of each word

            return (
              <Tag
                color={
                  REGISTER_STATUS_CONFIG[
                    status as keyof typeof REGISTER_STATUS_CONFIG
                  ]?.color
                }
              >
                {formattedStatus}
              </Tag>
            );
          }}
        />
        <Column
          title="Actions"
          key="actions"
          className="bg-white"
          width={"10%"}
          render={(values: any, data: any) => {
            const useDate = moment(data.useDate); // Parse the useDate
            const currentDate = moment(); // Get the current date
            const daysDifference = currentDate.diff(useDate, "days"); // Calculate the difference in days

            // Logic to determine if edit action is enabled
            const isEditEnabled =
              !isEmployee && // Only enable for non-employee roles
              (data.status !== "IN_USE" ||
                (data.status === "IN_USE" && daysDifference <= 3));

            return (
              <Space size={20}>
                <div
                  className="cursor-pointer flex align-center justify-center"
                  onClick={() => openModal(data)}
                >
                  <EyeOutlined
                    style={{
                      fontSize: "20px",
                    }}
                  />
                </div>

                {isEditEnabled ? (
                  <div
                    className="cursor-pointer flex align-center justify-center"
                    onClick={() => editDataHandler(data)}
                  >
                    <EditOutlined
                      style={{
                        fontSize: "20px",
                      }}
                    />
                  </div>
                ) : (
                  <div
                    className="flex align-center justify-center"
                    style={{
                      opacity: 0.3, // Makes the icon appear disabled
                      cursor: "not-allowed", // Disables click interaction
                    }}
                  >
                    <EditOutlined
                      style={{
                        fontSize: "20px",
                      }}
                    />
                  </div>
                )}
                <div
                  className="cursor-pointer flex align-center justify-center"
                  onClick={() => openLog(data)}
                >
                  <ClockCircleOutlined
                    style={{
                      fontSize: "20px",
                    }}
                  />
                </div>
              </Space>
            );
          }}
        />
      </Table>

      <SparePartDetailsModal
        visible={visible}
        onClose={closeModal}
        sparePartDetails={sparePartDetails}
      />

      <UseDateLogModal
        visible={logVisible}
        onClose={closeLogModal}
        itemCode={logItem}
        serviceCenterId={selectedServiceCenterId}
        data={[]} // Empty initial data since modal will fetch its own
        loading={false}
      />
    </div>
  );
};

export default RegisterSparePartTable;
